import {IDynamicFormField} from '@app/shared/models/dynamic.model';

export interface IClinicalHistory extends IDynamicFormField {
  fields: IDynamicFormField[];
  value: string;
  weeks?: string;
  days?: string;
}

export enum EClinicalHistoryFields {
  ClinicianComments = 'clinicianComments',
  GestationAge = 'gestationAge',
  CollectionDate = 'collectionDate',
  MarksMandatoryFields = 'marks mandatory fields',
}
